import { useContext, useState, useEffect } from 'react'
import { Link } from 'react-router'
import axios from 'axios'
import { getMessaging, onMessage } from 'firebase/messaging'
import { Dropdown, Layout, AlertContext } from '../widgets'
import * as routes from '../routes'
import authClient from '../auth/authClient'
import { PaginatedList } from '../components'
import { useTitle, withRouter } from '../shared'
import messageSettings from '../images/message-settings.svg'
import plusSign from '../images/plus-sign.svg'
import classNames from '../widgets/util'
import sadBoi from '../images/sad-boi.svg'
import { ConversationCell } from './components'

const ConversationListView = (props) => {
  const { handleError, showAlert } = useContext(AlertContext)
  const [messageSettingLevel, setMessageSettingLevel] = useState('ALL')
  const [timestamp, setTimestamp] = useState(Date.now())

  useTitle('Messages')

  useEffect(() => {
    axios.get(routes.getMessageSettingsUrl).then((response) => {
      setMessageSettingLevel(response.data.privacy)
    }).catch(handleError)
  }, [])

  useEffect(() => {
    (async () => {
      if (!await authClient.configureMessaging()) {
        showAlert({ title: 'Notifications Disabled', message: 'Enable browser notifications to receive updated DMs' })
      }
    })()
  }, [])

  useEffect(() => {
    onMessage(getMessaging(), (payload) => {
      refreshConversations()
    })
  }, [])

  const refreshConversations = () => {
    setTimestamp(Date.now())
  }

  const navigateToConversation = (id) => {
    props.router.navigate(routes.dynamic(routes.producerConversationPath, id))
  }

  const updateMessageSettings = (setting) => {
    if (setting === messageSettingLevel) {
      return
    }
    axios.put(routes.getMessageSettingsUrl, {
      privacy: setting
    }).then(() => {
      setMessageSettingLevel(setting)

    }).catch(handleError)
  }

  const messagesSettingsMenuAnchor = <img src={messageSettings} alt='message settings' className='conversation-settings-icon' />

  const messagesSettingsActions = [
    {
      title: 'Allow messages from',
      contentOverride: <div key='title' className='widgets-Dropdown-Action messages-settings_header'>Allow messages from</div>,
    },
    {
      title: 'Everyone',
      contentOverride: <div key='everyone' className='messages-settings_item widgets-Dropdown-Action' onClick={() => updateMessageSettings('ALL')}>
        <div>Everyone</div>
        <div className={classNames(messageSettingLevel === 'ALL' ? 'messages-settings_item_selected' : 'messages-settings_item_unselected')}></div>
      </div>,
    },
    {
      title: 'People you follow',
      contentOverride: <div key='follow' className='messages-settings_item widgets-Dropdown-Action' onClick={() => updateMessageSettings('FOLLOWING')}>
      <div>People you follow</div>
      <div className={classNames(messageSettingLevel === 'FOLLOWING' ? 'messages-settings_item_selected' : 'messages-settings_item_unselected')}></div>
    </div>,
    },
    {
      title: 'No one',
      contentOverride: <div key='noone' className='messages-settings_item widgets-Dropdown-Action' onClick={() => updateMessageSettings('NONE')}>
      <div>No one</div>
      <div className={classNames(messageSettingLevel === 'NONE' ? 'messages-settings_item_selected' : 'messages-settings_item_unselected')}></div>
    </div>,
    }
  ]

  return <div className='body-container'>
      <Layout>
        <Layout.Header>
          <div className='messages-header'>
            <div className='widgets-Layout-Header'>Messages</div>
            <div className='messages-header_actions'>
              <Dropdown anchor={messagesSettingsMenuAnchor} actions={messagesSettingsActions}/>
              <Link to={routes.producerNewMessagePath} className='messages-header_actions_new-message'>
              <img src={plusSign} alt='new message' /></Link>
            </div>
          </div>
        </Layout.Header>
          <PaginatedList
            key={`conversations-${timestamp}`}
            loadUrl={routes.conversationListUrl}
            cell={(props) => <ConversationCell {...props} navigateToConversation={navigateToConversation} />}
            cellItemPropName={'conversation'}
            emptyStateOverride={<div className='conversation_empty-state'>
              <img src={sadBoi} alt='sad boi' />
              <div>No messages yet. Start a new conversation by tapping the ‘plus’ icon!</div>
            </div>}
          />
      </Layout>
    </div>

}

export default withRouter(ConversationListView)
